module.exports = __webpack_public_path__ + "img/Mailbox5.e380fc45.svg";